import React, { Component } from 'react';
import { Button } from 'antd';
import { throttle } from 'lodash';

class LoadBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { onClick, children, className, type = 'primary' } = this.props;
    const handleClick = throttle(async () => {
      // 执行你的操作
      onClick();
    }, 3000);
    return (
      <Button onClick={handleClick} className={className} type={type}>{children}</Button>
    );
  }
}
export default LoadBtn;